<template>
  <div class="scene-item">
    <div
      class="scene-box"
      v-for="(items, indexs) in courseList"
      :key="indexs"
      @click="toSCeneDetails(items)"
    >
      <div class="scene-box-left">
        <img :src="items.imagePath" alt="" class="box-left-img" />
      </div>
      <div class="scene-box-right">
        <p class="scene-title"><span>路线</span>{{ items.name }}</p>
        <p class="scene-abstract" :title="items.desc">
          {{ items.desc }}
        </p>
        <div class="scene-learn">
          <p class="scene-courseNum" @click.stop="openCouse(items)">
            共{{ items.courseNum }}门课程
            <i :class="items.showAll ? 'icon-up' : 'icon-up icon-down'"></i>
          </p>
          <p class="scene-button"><a>学习</a></p>
        </div>
        <div v-if="items.showAll" class="scene-showstep">
          <div
            class="scene-list"
            v-for="(item, index) in items.currSceneStepsStr.split(',')"
            :key="index"
          >
            <div class="scene-text">
              <span class="green-radius"></span>
              <p class="scene-step">
                {{ index >= 9 ? index + 1 : "0" + `${index + 1}` }}. {{ item }}
              </p>
            </div>
            <div
              class="scene-decorate"
              v-if="items.currSceneStepsStr.split(',').length - 1 != index"
            ></div>
          </div>
					<div class="more-btn" v-if="items.courseNum > 4" @click.stop="openMore(items)">
            <span>{{items.moreFlag ? "展开 " : "收起"}}</span>
            <i :class="items.moreFlag ? 'icon-down' : 'icon-up' "></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { zhugeTrack } from "@/../public/public";
export default {
  props: {
    courseList: {},
  },
  data() {
    return {
      currCourseLiost: {}, // 要展示的数据
    };
  },
  mounted() {
		this.currCourseLiost = JSON.parse(JSON.stringify(this.courseList))
    this.courseList.forEach((val) => {
      val.showAll = true;
			if(val.sceneStepsStr){
				val.currSceneStepsStr = val.sceneStepsStr;
				let arr = val.sceneStepsStr.split(",")
				if(arr && arr.length > 4){
					let str = this.find(val.sceneStepsStr,',',3)
					val.currSceneStepsStr = val.currSceneStepsStr.substring(0,str)
					val.moreFlag = true
				}
			}
    });
    this.$forceUpdate();
  },
  methods: {
		find(str,cha,num){
			var x=str.indexOf(cha);
			for(var i=0;i<num;i++){
				x=str.indexOf(cha,x+1);
			}
			return x;
		},
		// 展开全部/收起课程
		openMore(item){
			if(item.moreFlag){
				item.currSceneStepsStr = item.sceneStepsStr;
				item.moreFlag = false
			}else{
				let str = this.find(item.sceneStepsStr,',',3)
				item.currSceneStepsStr = item.currSceneStepsStr.substring(0,str)
				item.moreFlag = true
			}
			this.$forceUpdate();
		},
		// 展示课程显示
    openCouse(item) {
      item.showAll = !item.showAll;
      this.$forceUpdate();
    },
    toSCeneDetails(data) {
      this.$router.push({
        name: "sceneDetails",
        query: {
          sceneId: data.id,
        },
      });
      zhugeTrack("Web_点击学习路线", {
        学习路线名称: data.name,
        学习路线学科: data.menuName,
      });
    },
  },
  computed: {
    showList: function () {
      return this.courseList;
    },
  },
};
</script>
<style lang="less" scoped>
.scene-item {
  .scene-box {
    cursor: pointer;
    width: 100%;
    // width: 1170px;
    // height: 228px;
    margin: 0 auto;
    background-color: #fff;
    display: flex;
    margin-bottom: 30px;
    padding: 30px 30px 30px 30px;
    border-radius: 4px;
    border: solid 1px #dcdfe4;
    .scene-box-left {
      .box-left-img {
        width: 276px;
        max-height: 152px;
      }
    }
    .scene-box-right {
      padding-left: 30px;
      width: 100%;
      .scene-title {
        color: #2a3c60;
        font-weight: 600;
        white-space: normal;
        word-break: break-all;
        word-wrap: break-word;
        font-size: 18px;
        line-height: 24px;
        span {
          vertical-align:middle;
          display: inline-block;
          background-color: #e88f34;
          width: 46px;
          height: 20px;
          line-height: 20px;
          color: #fff;
          font-size: 13px;
          text-align: center;
          border-radius: 2px;
          margin-right: 8px;
        }
      }
      .scene-abstract {
        color: #818896;
        font-size: 14px;
        padding-top: 15px;
        height: 78px;
        margin-bottom: 20px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
        white-space: normal;
        word-break: break-all;
        word-wrap: break-word;
      }
      .scene-learn {
        display: flex;
        justify-content: space-between;
        .scene-courseNum {
          color: #25c48b;
          font-size: 14px;
          font-weight: 600;
          line-height: 30px;
          padding-right: 15px;
          // flex:1;
          cursor: pointer;
        }
        .icon-up {
          width: 10px;
          height: 6px;
          display: inline-block;
          background: url("../../image/scene/icon-up.png") no-repeat;
          background-size: 10px 6px;
          background-position: center center;
          vertical-align: middle;
          margin-left: 10px;
        }
        .icon-down {
          background: url("../../image/scene/icon-down.png") no-repeat;
        }
        .scene-button {
          width: 80px;
          height: 30px;
          background-color: #25c48b;
          color: #fff;
          font-size: 14px;
          text-align: center;
          line-height: 30px;
          border-radius: 4px;
          cursor: pointer;
          &:hover {
            text-decoration: none;
            background: #28d899;
          }
        }
      }
      .scene-showstep {
        background-color: #f8fafd;
        padding: 20px 0 20px 37px;
        margin-top: 20px;
        .scene-list {
          // display: flex;
          // align-items: center;
          // margin-bottom: 30px;
          .scene-text {
            display: -webkit-box;
            align-items: center;
            .green-radius {
              width: 7px;
              height: 7px;
              background-color: #25c48b;
              border-radius: 50%;
              display: block;
            }
            .scene-step {
              margin-bottom: 0;
              padding-left: 10px;
              color: #2a3c60;
              font-size: 14px;
              // background-color: #F8FAFD;
              // width: 80%;
            }
          }
          .scene-decorate {
            width: 1px;
            height: 28px;
            background-color: #dcdfe4;
            margin-left: 3px;
          }
        }
        // 展开收起全部
        .more-btn{
          text-align: center;
          margin-top: 18px;
          cursor: pointer;
          span{
            font-size: 16px;
            color: #25c48b;
            line-height: 22px;
            display: inline-block;
            vertical-align:middle;
            margin-right: 14px;
          }
          i{
            width: 10px;
            height: 6px;
            display: inline-block;
            vertical-align:middle;
          }
          .icon-down{
            background: url('../../image/scene/icon-down.png') no-repeat;
          }
          .icon-up{
            background: url('../../image/scene/icon-up.png') no-repeat;
          }
        }
      }
    }
  }
  .scene-box:last-child {
    margin-bottom: 0px;
  }
  @media (max-width: 600px) {
    .scene-box {
      padding: 15px !important;
      .scene-box-left {
        img {
          max-width: 100% !important;
        }
      }
    }
  }
}
</style>